
import erResponseService from '../../../services/provider/erresponse'
import authService from '../../../services/auth'
import _ from 'lodash'
import { RECALL_STATUS, RECALL_STATUS_PROVIDER, RECALL_CLASSIFICATIONS,ER_RECALL_STATUS ,AFFECTED_PRODUCT_STATUS,OUTPUT_DATE_FORMAT} from '../../../misc/commons'
import SupplierModal from './SupplierModal'
import ResponseModal from './ResponseModal'
import {Notisphere_Er_Response_AgGrid} from '../../../misc/tableHeaders'
import { AG_GridCustomizedTableHeaders_Key} from '../../../misc/tableHeaders'
import ViewModal from '../../../components/part/shared/PreviewViewModal'
export default {
    components: {
        SupplierModal,
        ResponseModal,
        ViewModal
    },
    data() {
        return {
            OUTPUT_DATE_FORMAT: OUTPUT_DATE_FORMAT,
            delay: 700,
            clicks: 0,
            timer: null,
            total: 0,
            items: [],
            supplierModalKey: 0,
            respModalKey: 0,
            listSupplier: [],
            listSupplierEmail: [],
            listUserName: [],
            listProviderName: [],
            roleName: '',
            OrgType: '',
            count: 0,
            organizationId: null,
            userId: 0,
            search: {
                responseStatus: null,
                affectedProduct: null,
                respondent: null,
                supplierOrgId: null,
                providerOrgId: null,
                supplierOrgName: null,
                status: null,
                providername: null
            },
            user: {
                email: '',
                fname: '',
                lname: '',
                full_name: '',
                title: '',
                location: '',
                phone: '',
                photo: '',
                status: '',
                org_name: '',
                role: ''
            },
            header: [
                {
                    label: 'Status',
                    name: 'response_status',
                    sort: true,
                    row_text_alignment: 'text-center',
                    column_text_alignment: 'text-left',
                    column_classes: 'customalign-5percent',
                    row_classes: 'customalign-5percent wordbreakall'
                },
                {
                    label: 'Provider',
                    name: 'provider_name',
                    sort: true,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                    column_classes: 'customalign-15percent',
                    row_classes: 'customalign-15percent wordbreakall'
                },
                {
                    label: 'Supplier',
                    name: 'supplier_name',
                    sort: true,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                    column_classes: 'customalign-15percent',
                    row_classes: 'customalign-15percent wordbreakall'
                },
                {
                    label: 'Recall ID',
                    name: 'recallid',
                    sort: true,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                    column_classes: 'customalign-15percent',
                    row_classes: 'customalign-15percent wordbreakall'
                },
                {
                    label: 'Name',
                    name: 'recallname',
                    sort: true,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                    column_classes: 'customalign-10percent',
                    row_classes: 'customalign-10percent wordbreakall'
                },
                {
                    label: 'Documents',
                    name: 'extension',
                    sort: false,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                    column_classes: 'customalign-15percent',
                    row_classes: 'customalign-15percent wordbreakall'
                },
                {
                    label: 'Site',
                    name: 'recall_sites',
                    sort: true,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                    column_classes: 'customalign-10percent',
                    row_classes: 'customalign-15percent wordbreakall'
                },
                {
                    label: 'Notification Date',
                    name: 'notification_date',
                    sort: true,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                    column_classes: 'customalign-10percent',
                    row_classes: 'customalign-10percent wordbreakall'
                },
                {
                    label: 'Response Date',
                    name: 'response_date',
                    sort: true,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                    column_classes: 'customalign-10percent',
                    row_classes: 'customalign-10percent wordbreakall'
                },
                {
                    label: 'Respondent',
                    name: 'username',
                    sort: true,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                    visibility: this._checkRole('Reponder'),
                    column_classes: 'customalign-15percent',
                    row_classes: 'customalign-15percent wordbreakall'

                },
                {
                    label: 'Affected Product',
                    name: 'disposal_method',
                    sort: true,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                    column_classes: 'customalign-10percent',
                    row_classes: 'customalign-10percent wordbreakall'
                },
                {
                    label: '',
                    name: 'action',
                    row_text_alignment: 'text-center',
                    column_text_alignment: 'text-center',
                }
            ],

            listCategories: [],
            recall_status: _.cloneDeep(RECALL_STATUS),
            er_recall_status: _.cloneDeep(ER_RECALL_STATUS),
            recall_status_provider: RECALL_STATUS_PROVIDER,
            recall_classification: RECALL_CLASSIFICATIONS,
            affected_product_status: AFFECTED_PRODUCT_STATUS,

            //Ag-Grid
            rowModelType: 'serverSide',
            columnDefs: null,
            gridOptions: {
                onFilterChanged: this.onFilterChanged,
                onSortChanged: this.onSortChanged,
                getContextMenuItems: this.getContextMenuItems,
            },
            searchQuery: { pageNumber: 1, pageSize: 50, sort: null, colId: null },
            table_Connection_Data: this.$store.state.CustomizedHeaders.filter(s => s.userId == this.$store.state.user.id)[0],
            gridApi: null,
            columnApi: null
        }
    },
    beforeMount() {
        this.columnDefs = Notisphere_Er_Response_AgGrid
    },
    created(){
        this.roleName=this.$store.state.roleName
        this.rowModelType = 'serverSide'
        this.fetchProfile()
    },
    mounted() {
        this.findSupplier()
        this.findUserNameByOrgId()
        this.findProviderNameByOrgId()
        this.GetUserId
    },
    computed: {
        GetUserId()
        {
            return this.$store.state.user.id
        },
    },
    methods: {
        clicked(){
            console.log('clicked')
        },
        doubleClick(event){
            this.clicks++
            if(this.clicks === 1) {
                var self = this
                this.timer = setTimeout(function() {
                    self.clicks = 0
                }, this.delay)
            } else{
                clearTimeout(this.timer)
                this.viewResponseRecall(event)
                this.clicks = 0
            }
        },
        fetchProfile() {
            authService.getUserProfile().then(res => {
                if (!res.error) {
                    this.user = res.data.d
                }
            })
        },
        onCompleted() {
            this.findSupplier()
            this.findUserNameByOrgId()
            this.findProviderNameByOrgId()
            //this.fetchData()

        },
        supplierChange() {
            //this.fetchData()
        },
        findSupplier() {
            erResponseService.findMeta().then(resp => {
                this.listSupplier = [
                    ...resp.data.d
                ]
            })

        },
        findProviderNameByOrgId() {
            erResponseService.findProviderName().then(resp => {
                this.listProviderName = [
                    ...resp.data.d
                ]
            })

        },
        findUserNameByOrgId() {
            erResponseService.findUserName(this.$store.state.orgId).then(resp => {
                this.listUserName = [
                    ...resp.data.d
                ]
            })

        },

        fetchDelay() {
            this.$refs.table.fetchDelay()
        },
        addMoreClick() {
            this.supplierModalKey += 1
            this.$nextTick(() => {
                this.$refs.supplierModal.forceRerenderInsert(this.items)
            })
        },
        fetchDataOnSuccess(val,mode,item) {
            //this.fetchData()
            this.findSupplier()
            this.findUserNameByOrgId()
            this.findProviderNameByOrgId()
            if (val != null && val != undefined && val != '') {
                this._showToast(val, { variant: 'success' })
            }
            if (mode != null && mode != undefined && mode != '') {
                this.RespClick(item)
            }
        },
        addMoreRespClick(val,mode) {
            if(val.files.length > 0 && val.supplier_email != '' && val.supplier_email != null ){
                if (mode == 'btn'){
                    this.respModalKey += 1
                    this.$nextTick(() => {
                        this.$refs.respModal.forceRerenderInsert(val)
                    })
                }
                else if(mode == 'opt')
                {
                    if(val.status == 'ERROR')
                    {
                        this.supplierModalKey += 1
                        this.$nextTick(() => {
                            this.$refs.supplierModal.forceRerenderUpdate(val, this.items,'RES_UPDATE')
                        })
                    }
                    else if(val.status == undefined)
                    {
                        var isFile = true
                        val.files.forEach((x, i) => {
                            if(x.extension == null)
                            {
                                isFile = false
                            }
                            else
                            {
                                this.respModalKey += 1
                                this.$nextTick(() => {
                                    this.$refs.respModal.forceRerenderInsert(val)
                                })
                            }
                            if(!isFile){
                                this.supplierModalKey += 1
                                this.$nextTick(() => {
                                    this.$refs.supplierModal.forceRerenderUpdate(val, this.items,'RES_UPDATE')
                                })
                            }
                        })
                    }
                    else
                    {
                        this.respModalKey += 1
                        this.$nextTick(() => {
                            this.$refs.respModal.forceRerenderInsert(val)
                        })
                    }
                }
            }
            else
            {
                if(val.status == 'SENT')
                {
                    this.respModalKey += 1
                    this.$nextTick(() => {
                        this.$refs.respModal.forceRerenderInsert(val)
                    })
                }
                else if (mode == 'btn'){
                    if(val.status == 'ERROR')
                    {
                        this.respModalKey += 1
                        this.$nextTick(() => {
                            this.$refs.respModal.forceRerenderInsert(val)
                        })
                    }
                    else if(val.status == 'DRAFT')
                    {
                        this.supplierModalKey += 1
                        this.$nextTick(() => {
                            this.$refs.supplierModal.forceRerenderUpdate(val, this.items,'RES_UPDATE')
                        })
                    }
                    else
                    {
                        this.respModalKey += 1
                        this.$nextTick(() => {
                            this.$refs.respModal.forceRerenderInsert(val)
                        })
                    }
                }
                else
                {
                    this.supplierModalKey += 1
                    this.$nextTick(() => {
                        this.$refs.supplierModal.forceRerenderUpdate(val, this.items,'RES_UPDATE')
                    })
                }
            }
        },
        RespClick(val) {
            if(val.FileLen > 0 && val.response_email != '' && val.response_email != null){
                this.respModalKey += 1
                this.$nextTick(() => {
                    this.$refs.respModal.forceRerenderInsert(val)
                })
            }
        },
        viewRecall(item) {
            this.$router.push({ name: 'noti_er_Responses', params: { id: item.communicationId } })
        },
        editRecall(item, e) {
            this.$router.push({ name: 'prov_Recall_EditItem', params: { id: item.communicationId } })
            e.stopPropagation()
        },
        viewResponseRecall(val) {
            this.supplierModalKey += 1
            this.$nextTick(() => {
                this.$refs.supplierModal.forceRerenderUpdate(val, [],'VIEW')
            })
        },
        _checkRole(roleName) {
            if(this.$store.state.roleName==='Responder')
            {  return false}else{return true}

        },
        async download(dataurl, filename,contentType) {
            this.openExternalLink(dataurl)
        },
        getRecallByUId(communicationId) {
            this.EditClick(communicationId)
        },
        EditClick(val) {
            this.supplierModalKey += 1
            this.$nextTick(() => {
                this.$refs.supplierModal.forceRerenderUpdate(val, this.items,'UPDATE')
            })
        },
        deleteByGUID(val) {
            this._showConfirm('Are you sure you want to delete the recall, this cannot be undone?', { title: 'Delete Recall', variant: 'danger' }).then(confirm => {
                if (confirm) {
                    erResponseService.deleteResponderRecall(val.responder_recallid).then(resp => {
                        this.fetchDataOnSuccess('Recall deleted successfully',null)
                    })
                }
            })
        },
        findRECSVReport() {
            erResponseService.downloadCSVResponderRecall().then(resp => {
            })
        },
        findREXLSXReport() {
            erResponseService.downloadXLSXResponderRecall().then(resp => {
            })
        },

        // ----------------------------------- Ag-Grid -----------------------------------
        ViewClick(val) {
            var itemVal = null
            if(val.files != null || val.files !== 'undefined')
            {
                itemVal = {
                    extension: val.extension,
                    filename: val.filename,
                    signed_url: val.signed_url,
                    signed_url_review: val.signed_url_review,
                    fileSize: val.fileSize,
                    mimetype: val.mimetype
                }
            }
            this.viewModalKey += 1
            this.$nextTick(() => {
                this.$refs.viewModal.forceRerenderInsert(itemVal)
            })
        },
        fetchData(params) {
            this.applyState(params)
            this.setFilterModel(params)
            let that = this
            that.gridApi = params.api
            that.columnApi = params.columnApi
            //params.api.sizeColumnsToFit()
            const datasource = {
                getRows(params) {
                    that.searchQuery.colId = params.request?.sortModel[0]?.colId
                    that.searchQuery.sort = params.request?.sortModel[0]?.sort
                    that.search.response_status = params.request?.filterModel?.response_status?.filter
                    that.search.test_account = params.request?.filterModel?.test_account?.filter
                    that.search.provider_name = params.request?.filterModel?.provider_name?.filter
                    that.search.supplier_name = params.request?.filterModel?.supplier_name?.filter
                    that.search.recallid = params.request?.filterModel?.recallid?.filter
                    that.search.recallname = params.request?.filterModel?.recallname?.filter
                    that.search.recall_sites = params.request?.filterModel?.recall_sites?.filter
                    that.search.notification_date = params.request?.filterModel?.notification_date?.filter
                    that.search.response_date = params.request?.filterModel?.response_date?.filter
                    that.search.username = params.request?.filterModel?.username?.filter
                    that.search.disposal_method = params.request?.filterModel?.disposal_method?.filter
                    that.search.filterModel = that.gridApi.getFilterModel()
                    erResponseService.findErResponse({
                        ...that.searchQuery,
                        sortField: params.request?.sortModel[0]?.colId,
                        sortDirection: params.request?.sortModel[0]?.sort,
                        ...that.search
                    })
                        .then(resp => {
                            if (!resp.error) {
                                const recallsarray = []
                                resp.data.d.c.forEach(x => {
                                    x.loggedInUserId = that.user_Id
                                })
                                for (var i = 0; i < resp.data.d.c.length; i++) {

                                    if (resp.data.d.c[i].document == null || resp.data.d.c[i].document == 'undefined' ) {
                                        resp.data.d.c[i].document = null
                                    }
                                    if(resp.data.d.c[i].distributorName === 'undefined')
                                    {
                                        resp.data.d.c[i].distributorName = null
                                    }
                                    if(resp.data.d.c[i].disposal_method === 'BLANK')
                                    {
                                        resp.data.d.c[i].disposal_method = ''
                                    }
                                    recallsarray.push(resp.data.d.c[i])
                                }
                                that.item = resp.data.d.c
                                that.total = resp.data.d.t
                                //return resp.data.d.c
                                if(that.total == 0){
                                    that.gridApi.showNoRowsOverlay()
                                }
                                else{
                                    that.gridApi.hideOverlay()
                                }
                                return recallsarray
                            }
                        }).then(response => {
                            params.successCallback(response)
                        })
                        .catch(error => {
                            console.error(error)
                            params.failCallback()
                        })
                }
            }
            // register datasource with the grid
            params.api.setServerSideDatasource(datasource)
        },
        applyState(params) {
            var tableState = JSON.parse(localStorage.getItem(AG_GridCustomizedTableHeaders_Key))?.filter(s => s.userId == this.$store.state.user.id)[0]
            var columnState = tableState?.Notisphere_Login?.Er_Response_Headers
            if (columnState) {
                const actionCol = columnState.find(col => col.colId === 'actions')
                columnState = columnState.filter(col => col.colId !== 'actions')
                if (actionCol) {
                    columnState.push(actionCol)
                }
                params.columnApi.applyColumnState({
                    state: columnState,
                    applyOrder: true
                })
            }
        },
        setFilterModel(params) {
            var tableState = JSON.parse(localStorage.getItem(AG_GridCustomizedTableHeaders_Key))?.filter(s => s.userId == this.$store.state.user.id)[0]
            var filterModel = tableState?.Notisphere_Login?.Er_Response_Filters
            if (filterModel) {
                params.api.setFilterModel(filterModel)
            }
        },
        onCellClicked(params) {
            if(params.colDef.field === 'files')
            {
                if(params.event.target.dataset.action != undefined)
                {
                    if(params.event.target.dataset.action.includes('viewclick'))
                    {

                        for(let i=0 ;i< params.data.files.length;i++)
                        {
                            if (params.event.target.dataset.action === 'viewclick_' + params.data.files[i].responder_document) {
                                return this.ViewClick(params.data.files[i])
                            }
                        }
                    }
                }

            }else if (params.column.colId === 'actions') {

                if(params.event.target.dataset.action === 'view')
                {
                    this.viewResponseRecall(params.data)
                }

                return
            } else
            {
                this.viewResponseRecall(params.data)
            }
        },
        saveState(params) {
            this.table_Connection_Data.Notisphere_Login.Er_Response_Headers = params.columnApi.getColumnState()
            localStorage.setItem(AG_GridCustomizedTableHeaders_Key, JSON.stringify(this.$store.state.CustomizedHeaders))
        },
        onFilterChanged(params) {
            this.table_Connection_Data.Notisphere_Login.Er_Response_Filters = params.api.getFilterModel()
            localStorage.setItem(AG_GridCustomizedTableHeaders_Key, JSON.stringify(this.$store.state.CustomizedHeaders))
            this.saveState(params)
            this.fetchData(params)
        },
        onSortChanged(event) {
            this.saveState(event)
            this.fetchData(event)
        },
        getContextMenuItems(params) {
            let that = this
            const defaultItems = params.defaultItems
            const filteredItems = defaultItems.filter((item) => item !== 'export')
            that.searchQuery.colId = params.request?.sortModel[0]?.colId
            that.searchQuery.sort = params.request?.sortModel[0]?.sort
            that.search.response_status = params.request?.filterModel?.response_status?.filter
            that.search.test_account = params.request?.filterModel?.test_account?.filter
            that.search.provider_name = params.request?.filterModel?.provider_name?.filter
            that.search.supplier_name = params.request?.filterModel?.supplier_name?.filter
            that.search.recallid = params.request?.filterModel?.recallid?.filter
            that.search.recallname = params.request?.filterModel?.recallname?.filter
            that.search.recall_sites = params.request?.filterModel?.recall_sites?.filter
            that.search.notification_date = params.request?.filterModel?.notification_date?.filter
            that.search.response_date = params.request?.filterModel?.response_date?.filter
            that.search.username = params.request?.filterModel?.username?.filter
            that.search.disposal_method = params.request?.filterModel?.disposal_method?.filter
            that.search.filterModel = that.gridApi.getFilterModel()
            const customMenuItem = {
                name: 'Excel Export',
                action: async function () {
                    const email = that.$store.state.user.email
                    const query_param = {
                        ...that.searchQuery,
                        sortField: params.request?.sortModel[0]?.colId,
                        sortDirection: params.request?.sortModel[0]?.sort,
                        ...that.search,
                        email: email
                    }
                    const resp = await erResponseService.downloadAgGridNotisphereErResponsesXLSX(query_param)
                    if (!resp.error) {
                        that._showOk(resp.data.d.message, {
                            variant: 'success',
                            title: 'Message',
                            buttonTitle: 'Ok',
                        })
                    }
                },
                icon: '<span class="ag-icon ag-icon-excel"></span>',
            }

            const allItems = [...filteredItems, customMenuItem]
            return allItems
        },
    }
}